import { HowItWorksPage } from './pages/HowItWorksPage';

export const howItWorksRoutes = [
  { path: 'how-it-works', element: <HowItWorksPage /> },
];
